import React, {lazy, Suspense, useState} from 'react';
import "./Product.scss";

const Product = (props) => {
  const [attributes, setAttributes] = useState(props)
  let ComponentLazy = null;

  if(attributes.page === "moka") { ComponentLazy = lazy(() => import("./Content/Moka"));}
  else if(attributes.page === "wework") { ComponentLazy = lazy(() => import("./Content/Wework"));}

  return (
    <div className="Product col-xs-12" id='Product'>
      <Suspense fallback={<div>Loading...</div>}>
        <ComponentLazy attributes={props}/>
      </Suspense>
    </div>
  )
}
export default Product;
